var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.171,
    height: 38.814,
    viewBox: "0 0 30.171 38.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-159.125 -1177.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_4",
    "data-name": "XMLID 86 4",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M180.1,1177.348H161.245v38.814H189.3v-29.757Z",
    fill: "#5d5d5d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_4",
    "data-name": "XMLID 85 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M180.1,1177.348l9.2,9.068h-9.2Z",
    fill: "#5d5d5d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_4",
    "data-name": "XMLID 84 4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1465",
    "data-name": "Rectangle 1465",
    width: 28,
    height: 13.286,
    transform: "translate(159.125 1195.541)",
    fill: "#b14b38"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_4",
    "data-name": "XMLID 83 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M159.125,1208.824l2.127,1.805v-1.805Z",
    fill: "#b14b38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_.pdf",
    "data-name": " .pdf",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M163.843,1205.95a.66.66,0,0,1,.468-1.128.606.606,0,0,1,.452.192.682.682,0,0,1,0,.936.609.609,0,0,1-.452.191A.64.64,0,0,1,163.843,1205.95Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M168.1,1200.488a2.556,2.556,0,0,1,1.325-.335,2.73,2.73,0,0,1,1.409.372,2.625,2.625,0,0,1,.995,1.048,3.285,3.285,0,0,1,.361,1.569,3.359,3.359,0,0,1-.361,1.574,2.653,2.653,0,0,1-2.4,1.457,2.543,2.543,0,0,1-1.314-.335,2.379,2.379,0,0,1-.867-.835v3.84h-.968v-8.595h.968v1.075A2.314,2.314,0,0,1,168.1,1200.488Zm2.835,1.505a1.836,1.836,0,0,0-.718-.745,1.988,1.988,0,0,0-.994-.255,1.931,1.931,0,0,0-.984.261,1.9,1.9,0,0,0-.724.755,2.569,2.569,0,0,0,0,2.3,1.907,1.907,0,0,0,.724.756,1.931,1.931,0,0,0,.984.26,1.952,1.952,0,0,0,.994-.26,1.867,1.867,0,0,0,.718-.756,2.425,2.425,0,0,0,.266-1.164A2.372,2.372,0,0,0,170.938,1201.993Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M173.512,1201.573a2.622,2.622,0,0,1,.994-1.048,2.751,2.751,0,0,1,1.42-.372,2.639,2.639,0,0,1,1.266.314,2.261,2.261,0,0,1,.894.824v-3.085h.978v7.871h-.978v-1.095a2.261,2.261,0,0,1-.851.856,2.538,2.538,0,0,1-1.319.335,2.651,2.651,0,0,1-2.4-1.457,3.348,3.348,0,0,1-.362-1.574A3.274,3.274,0,0,1,173.512,1201.573Zm4.308.431a1.881,1.881,0,0,0-.718-.75,2.036,2.036,0,0,0-1.984-.006,1.857,1.857,0,0,0-.713.745,2.372,2.372,0,0,0-.265,1.149,2.425,2.425,0,0,0,.265,1.164,1.889,1.889,0,0,0,.713.756,1.926,1.926,0,0,0,.989.26,1.956,1.956,0,0,0,1-.26,1.873,1.873,0,0,0,.718-.756,2.4,2.4,0,0,0,.266-1.154A2.371,2.371,0,0,0,177.82,1202Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M183.117,1201.046h-1.223v5.031h-.968v-5.031h-.756v-.8h.756v-.414a1.828,1.828,0,0,1,.505-1.431,2.394,2.394,0,0,1,1.622-.452v.808a1.288,1.288,0,0,0-.9.25,1.108,1.108,0,0,0-.26.825v.414h1.223Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.8182135acff902b64faf027271a09b22.svg";
export { ForwardRef as ReactComponent };